<template>
  <v-app>
    <v-navigation-drawer v-model="drawer" app>
      <v-list dense>
        <v-list-item v-for="(item, i) in items" :key="i" :to="item.to" router link exact>
          <v-list-item-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title v-text="item.title" />
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="!isInstalled && getInstallAppPrompt" @click="OnInstallApp" link exact>
          <v-list-item-action>
            <v-icon>mdi-plus-box</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Installa App</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="updateExists" @click="refreshApp" link exact>
          <v-list-item-action>
            <v-icon>mdi-reload</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Aggiorna</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="resetData" link exact>
          <v-list-item-action>
            <v-icon>mdi-alert-decagram</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>RESET</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar app color="primary" dark>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <router-link to="/">
        <v-img
          alt="Logo"
          class="shrink mr-2"
          contain
          src="./assets/logo.svg"
          transition="scale-transition"
          width="40"
          height="20"
        />
      </router-link>

      <v-toolbar-title v-if="$vuetify.breakpoint.lgAndUp">nv1500</v-toolbar-title>

      <v-spacer></v-spacer>
      <template v-if="getSignedIn">
        <v-img
          v-if="getProfile.photoURL"
          alt="Profile pic"
          class="shrink-mr-2"
          contain
          :title="getProfile.displayName"
          :src="getProfile.photoURL"
          max-width="48"
          max-height="48"
        />
        <v-icon v-else>mdi-account-box-outline</v-icon>
      </template>
      <v-app-bar-nav-icon
        v-if="updateExists"
        transition="scale-transition"
        @click.stop="refreshApp"
      >
        <v-icon>mdi-reload</v-icon>
      </v-app-bar-nav-icon>
    </v-app-bar>
    <v-content>
      <v-bottom-sheet
        :inset="$vuetify.breakpoint.lgAndUp"
        max-width="650"
        v-model="showInstallModal"
      >
        <v-alert prominent dark color="primary lighten-1">
          <v-row align="center">
            <v-col class="grow">
              <v-img
                alt="Logo"
                class="shrink mr-2"
                contain
                src="./assets/logo.svg"
                transition="scale-transition"
                width="40"
                height="25"
              />

              <span class="title">Aggiungi alla Home</span>
              <br />
              <span class="caption">Comodo per aggiornare i dati.</span>
            </v-col>
            <v-col class="shrink">
              <v-btn @click="OnInstallApp" fab color="accent">
                <v-icon>mdi-plus-box</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-alert>
      </v-bottom-sheet>
      <InstalledThanks v-if="actionInstalled" />
      <v-snackbar v-model="snackWithButtons" :timeout="timeout" top right>
        Aggiornamento disponibile
        <v-spacer />
        <v-btn dark text color="#00f500" @click.stop="refreshApp">
          <v-icon>mdi-reload</v-icon>Aggiorna
        </v-btn>
        <v-btn dark icon @click="snackWithButtons = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-snackbar>
      <v-container class="fill-height" fluid>
        <router-view></router-view>
      </v-container>
    </v-content>
    <v-footer color="indigo" app>
      <span class="white--text">&copy; 2020 CNR ISC - (ver. {{ appVersion }})</span>
    </v-footer>
  </v-app>
</template>

<script>
import InstalledThanks from "@/components/InstalledThanks";
import { mapGetters, mapActions } from "vuex";
import firebase from "firebase/app";
export default {
  name: "MyApp",
  components: { InstalledThanks },
  methods: {
    ...mapActions(["setShowInstallPrompt"]),
    showRefreshUI(e) {
      this.registration = e.detail;
      this.updateExists = true;
      this.snackWithButtons = true;
    },
    refreshApp() {
      this.updateExists = false;
      this.snackWithButtons = false;
      if (!this.registration || !this.registration.waiting) {
        return;
      }
      this.registration.waiting.postMessage("skipWaiting");
    },
    resetData() {
      this.$store.dispatch("clearHousehold");
    },
    OnInstallApp() {
      this.showInstallModal = false;
      const deferredPrompt = this.getInstallAppPrompt;
      this.setShowInstallPrompt(false);
      if (deferredPrompt && deferredPrompt.prompt) deferredPrompt.prompt();
      deferredPrompt.userChoice.then(choiceResult => {
        if (choiceResult.outcome === "accepted") {
          this.$gtag.event("accepted", {
            event_category: "engagement",
            event_label: "Add to Homescreen",
            value: 5
          });
          this.actionInstalled = true;
          // console.log('User accepted the install prompt');
          // this.$store.commit("INSTALL_APP_PROMPT", false);
        } else {
          this.$gtag.event("refused", {
            event_category: "engagement",
            event_label: "Add to Homescreen",
            value: 0
          });
          // this.$store.commit("INSTALL_APP_PROMPT", false);
          // console.log('User dismissed the install prompt');
        }
      });
    }
  },
  computed: {
    ...mapGetters([
      "getProfile",
      "getSignedIn",
      "getInstallAppPrompt",
      "getShowInstallAppPrompt",
      "appVersion"
    ]),
    isInstalled() {
      return (
        navigator.standalone || matchMedia("(display-mode: standalone)").matches
      );
    }
  },
  watch: {
    getShowInstallAppPrompt: function(val) {
      if (val && !this.isInstalled) {
        this.showInstallModal = true;
        this.$gtag.event("show", {
          event_category: "engagement",
          event_label: "Add to Homescreen",
          value: 1
        });
      }
    }
  },
  data: () => ({
    actionInstalled: false,
    drawer: false,
    snackWithButtons: false,
    canInstall: true,
    showInstallModal: false,
    timeout: 5000,
    refreshing: false,
    registration: null,
    updateExists: false,
    items: [
      {
        icon: "mdi-home",
        title: "Home",
        to: "/"
      },
      {
        icon: "mdi-help-circle-outline",
        title: "About",
        to: "/About"
      },
      {
        icon: "mdi-information-variant",
        title: "Privacy",
        to: "/Privacy"
      },
      {
        icon: "mdi-login",
        title: "Login",
        to: "/Login"
      },
      {
        icon: "mdi-logout",
        title: "Logout",
        to: "/Logout"
      }
    ]
  }),
  mounted() {
    firebase.auth().onAuthStateChanged(
      function(auth) {
        this.$store.dispatch("SetAuthentication", auth);
        /*
        if (!auth) {
          firebase
            .auth()
            .signInAnonymously()
            .catch(error => this.$store.commit("SET_ERROR", error.message));
        }
        */
      }.bind(this)
    );
  },
  created() {
    document.addEventListener("swUpdated", this.showRefreshUI, { once: true });
    if (navigator.serviceWorker) {
      navigator.serviceWorker.addEventListener("controllerchange", () => {
        if (this.refreshing) return;
        this.refreshing = true;
        window.location.reload();
      });
    }
    // https://web.dev/customize-install/
    window.addEventListener("beforeinstallprompt", e => {
      // Prevent the mini-infobar from appearing on mobile
      e.preventDefault();
      // Stash the event so it can be triggered later.
      this.$store.commit("INSTALL_APP_PROMPT", e);
    });
    window.addEventListener("appinstalled", () => {
      this.$store.commit("INSTALL_APP_PROMPT", false);
      this.$gtag.event("installed", {
        event_category: "engagement",
        event_label: "Add to Homescreen",
        value: 10
      });
    });
  }
};
</script>
